module.exports = __webpack_public_path__ + "static/media/iphone-box-view.d19fda9b.jpg";